import type { Node } from '@atlaskit/editor-prosemirror/model';
import { token } from '@atlaskit/tokens';

import { ALIGNMENT, BORDER, CORNERS, ITEM, type LinksMenuParameters } from './types';

export const mockLinksMenuData: LinksMenuParameters = {
	version: '1',
	items: [
		{
			itemId: '1',
			type: ITEM.MENU,
			title: 'Teams',
			childItems: [
				{
					itemId: '2',
					type: ITEM.LINK,
					title: 'About us',
					link: 'https://www.example.com/about-us',
				},
				{
					itemId: '3',
					type: ITEM.MENU,
					title: 'Company Hub',
					childItems: [
						{
							itemId: '4',
							type: ITEM.LINK,
							title: 'Benefits',
							link: 'https://www.example.com/benefits',
						},
						{
							itemId: '5',
							type: ITEM.MENU,
							title: 'Planning',
							childItems: [
								{
									itemId: '6',
									type: ITEM.LINK,
									title: 'Product - Super Long Corporate Title Needed Here',
									link: 'https://www.example.com/product',
								},
								{
									itemId: '7',
									type: ITEM.MENU,
									title: 'Design',
									childItems: [
										{
											itemId: '8',
											type: ITEM.LINK,
											title: 'Contact',
											link: 'https://www.example.com/contact',
										},
										{
											itemId: '9',
											type: ITEM.MENU,
											title: 'Resources',
											childItems: [
												{
													itemId: '10',
													type: ITEM.LINK,
													title: 'Blog',
													link: 'https://www.example.com/blog',
												},
												{
													itemId: '11',
													type: ITEM.LINK,
													title: 'Support',
													link: 'https://www.example.com/support',
												},
												{
													itemId: '12',
													type: ITEM.LINK,
													title: 'Outreach',
													link: 'https://www.example.com/outreach',
												},
											],
										},
									],
								},
							],
						},
					],
				},
			],
		},
		{
			itemId: '13',
			type: ITEM.LINK,
			title: 'Home',
			link: 'https://www.example.com',
		},
	],
	styles: {
		alignment: ALIGNMENT.CENTER,
		fillColor: token('elevation.surface.overlay'),
		borderColor: token('color.background.accent.gray.subtler'),
		border: BORDER.NONE,
		cornerStyle: CORNERS.SHARP,
		textColor: token('color.text'),
		highlightColor: token('color.text'),
	},
};
type SemiNode = Pick<Node, 'attrs'> & {
	type: string;
};
export const mockRawNodeLinksMenuExtension: SemiNode = {
	type: 'extension',
	attrs: {
		extensionType: 'com.atlassian.confluence.links-menu',
		extensionKey: 'links-menu',
		parameters: mockLinksMenuData,
		text: null,
		layout: 'default',
		localId: 'some-localId-1',
	},
};
